export default function updateServerModuleReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'UPDATE_SERVER_MODULE_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'UPDATE_SERVER_MODULE_ERROR':
            return {...state, ...{error: action.error}};

        case 'UPDATE_SERVER_MODULE_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}